import { observer } from "mobx-react-lite";
import { MainMenuItemCategory } from "../../services/menu/MenuStorageService";
import { Badge, Box, CircularProgress, Divider, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip, Typography } from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { shopHistoryStorage } from "e.sic-platform.webclient/src/services/shop/ShopHistoryStorage";
import { ActivityTypes } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import { authentication } from "e.sic-platform.webclient/src/services/authentication/Authentication";

export default observer(function MenuButton(props: {item: MainMenuItemCategory, menuOpen: boolean}) {
    const {item, menuOpen} = {...props};

    const {pathname} = useLocation();
    const navigate = useNavigate();
    
    const openInNewTab = (url: string) => {
        const newWindow = window.open(url, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
    };

    const itemSelected = useCallback(
        (path: string) => pathname.includes(path),
    [pathname]);
    
    const goToPath = useCallback((path: string) => {
        navigate(path);
    }, [])

    return (
        <>
            {item.hide && <></>}
            {item.withDivider && <Divider sx={{ borderColor: "white" }} />}
            {!item.hide &&
            <ListItem key={item.name}>
            <Tooltip
                title={translationService.translate("general." + item.name)}
                placement="right"
            >
                <ListItemButton
                sx={{ display: "flex", alignItems: "center", p: 0 }}
                onClick={() => {
                    if (item.name === "smart-manager") {
                        openInNewTab(item.path!);
                    } else if (authentication.anonymous && item.name !== "shop") {
                        // The shop stays public so guests can review prices; buying asks for login.
                        // Signed-out guest opening an app → trigger login, return to it.
                        authentication.loginToAccess(item.path!);
                    } else {
                        goToPath(item.path!);
                    }
                }}
                >
                <MenuIcon 
                    icon={itemSelected(item.path!) ? item.iconSelected : item.icon} service={item.service}
                />
                {menuOpen && (
                    <ListItemText>
                    <Typography noWrap
                        color={itemSelected(item.path!) ? "primary" : "white"}
                    >
                        {translationService.translate("general." + item.name)}
                    </Typography>
                    </ListItemText>
                )}
                </ListItemButton>
            </Tooltip>
            </ListItem>}
        </>
    )
})

const MenuIcon = observer(function MenuIcon(props: {icon: any, service: ActivityTypes[] | undefined}) {
    const loading = useMemo(
        () => props.service === undefined ? 0 : shopHistoryStorage.getServiceProgressCount(props.service)
    , [shopHistoryStorage.history]);
    
    return (
        <ListItemIcon>
            <Box position="relative" display="inline-flex">
                {props.icon}
                {loading > 0 && (
                    <Badge 
                        badgeContent={loading}
                        color="primary"
                        sx={{
                            position: "absolute",
                            zIndex: 1,
                            left: "11%",
                            top: "11%"
                        }}
                    >
                        <CircularProgress size={40} />
                    </Badge>
                )}
            </Box>
        </ListItemIcon>
    )
})